import React, { memo, useEffect, useRef, useState } from 'react';
import { PopConfirm, Button, TextArea } from 'tea-component';
import classNames from 'classnames';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import SvgIcon from '@home/components/SvgIcon';
import { useClickAway } from 'ahooks';

interface IMessageItem<S = string> {
  id: number;
  text: S;
  textEn: S;
}

interface IFeedbackPopConfirmProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: (data: {
    feedback: string[];
    feedbackContent: string;
    list: string[];
  }) => void;
  messageList: IMessageItem[];
  title: string;
}

// Ai点踩反馈弹框
export const FeedbackPopConfirm = memo(
  ({
    visible,
    onClose,
    onConfirm,
    messageList,
    title,
  }: IFeedbackPopConfirmProps) => {
    const { formatMessage, locale } = useIntl();
    const [active, setActive] = useState<string[]>([]);
    const [text, setText] = useState('');
    const timer: any = useRef(null);
    const isEn = locale === LANGUAGE_EN;

    useClickAway(
      () => {
        timer.current = setTimeout(() => {
          visible && onClose();
        }, 100);
      },
      () => document.querySelector('.dba-feedback-pop-confirm'),
    );

    // 重置
    useEffect(() => {
      setActive([]);
      setText('');
      return () => {
        clearTimeout(timer.current);
      };
    }, [visible]);

    // 点击勾选
    const handleActive = (value: string) => {
      setActive((res) => {
        if (res.includes(value)) {
          return res.filter((item) => item !== value);
        }
        return [...res, value];
      });
    };

    // 点击确认
    const handleConfirm = (value: string) => {
      // onClose();
      setText(value);
      onConfirm({ feedback: active, feedbackContent: text, list: messageList });
    };

    return (
      <PopConfirm
        visible={visible}
        className="dba-feedback-pop-confirm dba-nav-menu-overlay"
        title={
          <div className="dba-feedback-pop-confirm-title">
            <span>{title}</span>
            <span>
              <SvgIcon type="clonse" onClick={onClose} />
            </span>
          </div>
        }
        overlayClassName='dba-nav-menu-overlay'
        message={
          <>
            <div className="dba-feedback-pop-confirm-list">
              {messageList?.map((item) => (
                <div
                  className={classNames('dba-feedback-pop-confirm-list-item', {
                    'dba-feedback-pop-confirm-list-item-active':
                      active.includes(item.id),
                  })}
                  onClick={() => handleActive(item.id)}
                  key={item.id}
                >
                  {isEn ? item.textEn : item.text}
                </div>
              ))}
              <TextArea
                size={'full'}
                value={text}
                onChange={(value) => setText(value)}
                placeholder={formatMessage({
                  id: 'dba_chat_feedback_placeholder',
                })}
              />
            </div>
          </>
        }
        escapeWithReference
        arrowPointAtCenter
        placement="bottom-end"
        footer={(close) => (
          <div className="dba-feedback-pop-confirm-footer">
            <Button
              className="dba-feedback-pop-confirm-footer-confirm"
              onClick={handleConfirm}
              overlayClassName='dba-nav-menu-overlay'
            >
              {formatMessage({ id: 'aigc_common_confirm' })}
            </Button>
            <Button
              className="dba-feedback-pop-confirm-footer-cancel"
              onClick={() => {
                close();
                onClose();
              }}
            >
              {formatMessage({ id: 'aigc_common_cancel' })}
            </Button>
          </div>
        )}
      ></PopConfirm>
    );
  },
);
